(() => {
  function pauseSlide(slide) {
    if (!slide) return;
    slide.classList.remove('is-playing');
    const media = slide.querySelector('.product-video-carousel-sht__media');
    if (media) media.hidden = true;

    const video = slide.querySelector('video');
    if (video) video.pause();
  }

  function getPerView() {
    return window.innerWidth <= 749 ? 2 : 3;
  }

  function setupCarousel(root) {
    const track = root.querySelector('[data-pvcs-track]');
    const slides = Array.from(root.querySelectorAll('[data-pvcs-slide]'));
    const prev = root.querySelector('[data-pvcs-prev]');
    const next = root.querySelector('[data-pvcs-next]');
    const dots = root.querySelector('[data-pvcs-dots]');
    if (!track || !slides.length || !prev || !next || !dots) return;

    let page = 0;

    function pageCount() {
      return Math.max(1, Math.ceil(slides.length / getPerView()));
    }

    function visibleCount() {
      return Math.max(1, Math.min(slides.length, getPerView()));
    }

    function renderDots() {
      dots.innerHTML = '';
      for (let index = 0; index < pageCount(); index += 1) {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'product-video-carousel-sht__dot';
        button.setAttribute('aria-label', `Go to video page ${index + 1}`);
        button.addEventListener('click', () => {
          page = index;
          update();
        });
        dots.appendChild(button);
      }
    }

    function update() {
      const pages = pageCount();
      page = Math.min(page, pages - 1);
      const perView = visibleCount();
      root.style.setProperty('--pvcs-per-view', perView);
      const slideWidth = slides[0].getBoundingClientRect().width;
      const offset = page * perView * slideWidth;
      const hasOverflow = slides.length > perView;
      track.style.transform = `translateX(-${offset}px)`;

      prev.disabled = page === 0;
      next.disabled = page >= pages - 1;
      prev.hidden = !hasOverflow;
      next.hidden = !hasOverflow;
      dots.hidden = !hasOverflow;

      dots.querySelectorAll('.product-video-carousel-sht__dot').forEach((dot, index) => {
        dot.classList.toggle('is-active', index === page);
        dot.setAttribute('aria-current', index === page ? 'true' : 'false');
      });
    }

    slides.forEach((slide) => {
      const playButton = slide.querySelector('[data-pvcs-play]');
      const media = slide.querySelector('.product-video-carousel-sht__media');
      if (!playButton || !media) return;

      playButton.addEventListener('click', () => {
        slides.forEach((otherSlide) => {
          if (otherSlide !== slide) pauseSlide(otherSlide);
        });

        slide.classList.add('is-playing');
        media.hidden = false;
        const video = slide.querySelector('video');
        if (video) video.play();
      });
    });

    prev.addEventListener('click', () => {
      if (page <= 0) return;
      slides.forEach(pauseSlide);
      page -= 1;
      update();
    });

    next.addEventListener('click', () => {
      if (page >= pageCount() - 1) return;
      slides.forEach(pauseSlide);
      page += 1;
      update();
    });

    window.addEventListener('resize', () => {
      renderDots();
      update();
    });

    renderDots();
    update();
  }

  document.querySelectorAll('[data-pvcs-root]').forEach(setupCarousel);
})();
